import { render, staticRenderFns } from "./InstitutionSelectDialog.vue?vue&type=template&id=25e45bb9&scoped=true&"
import script from "./InstitutionSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./InstitutionSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./InstitutionSelectDialog.vue?vue&type=style&index=0&id=25e45bb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e45bb9",
  null
  
)

export default component.exports